import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { IAlert } from 'app/components/bootstrap/alerts/alerts.component';
import { DynamicDetailComponent } from 'app/pages/full-pages/admin/dynamic-detail/dynamic-detail.component';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Chartist from 'chartist';
import { ChartType, ChartEvent } from "ng-chartist";
import ChartistTooltip from 'chartist-plugin-tooltips-updated';
import { filter } from 'rxjs/operators';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Toast, ToastrService } from 'ngx-toastr';

declare var require: any;

const data: any = require('../../shared/data/chartist.json');
export interface Chart {
  type: ChartType;
  data: Chartist.IChartistData;
  options?: any; 
  responsiveOptions?: any;
  events?: ChartEvent;
  // plugins?: any;
}
export interface DynamicDetailData {
  id: number;
  key: string;
  value: string;
}
export interface DynamicDetailData2 {
  id: number;
  key: string;
  value: string;
}
@Component({
  selector: 'app-latest-dashboard',
  templateUrl: './latest-dashboard.component.html',
  styleUrls: ['./latest-dashboard.component.scss']
})
export class LatestDashboardComponent implements OnInit {
  public general_info: Array<IAlert> = [];

  row_data:any
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: false }) dynamicContainer: ViewContainerRef;
  guideline_data:any

  usersLength:any;
  courseLength:any;
  studentLength:any;
  businessLength:any;
  courseCount:any
  stats_data:any
  hot_links:any
  // general_info:any
  quick_links:any
  warn_message:any
  guideline_section7:any
  @ViewChild('todayThoughtContainer', { read: ViewContainerRef, static: false }) todayThoughtContainer: ViewContainerRef;

  today_thought_data:any
  data_section8:any=[]

  baseUrl = environment.apiUrls.baseUrl
  showAlert: boolean = true;
  

  activeTab: string;
  app:any
  tasks:any
  user:any
  constructor(private apiService:ApiService,private modalService: NgbModal,
    private spinner: NgxSpinnerService,private resolver: ComponentFactoryResolver,
    public toastr: ToastrService,) {
    this.user= JSON.parse(localStorage.getItem('user')).id
    this.currentEmployee(this.user)
  }
  WidgetlineChart: Chart = {
    type: 'Line', data: data['Dashboard1_WidgetlineChart'],
    options: {
      axisX: {
        showGrid: false,
        showLabel: false,
        offset: 0
      },
      axisY: {
        showGrid: false,
        low: 40,
        showLabel: false,
        offset: 0
      },
      plugins: [
        ChartistTooltip({
          appendToBody: true,
          currency: '$',
          pointClass: 'ct-point-regular'
        })
      ],
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 0
      }),
      fullWidth: true
    },
    events: {
      draw(data: any): void {
        if (data.type === 'point') {
          var circle = new Chartist.Svg('circle', {
            cx: data.x,
            cy: data.y,
            r: 4,
            'ct:value': data.value.y,
            'ct:meta': data.meta,
            style: 'pointer-events: all !important',
            class: 'ct-point-regular'
          });
          data.element.replace(circle);
        }
      }
    }
  };
  // Line chart configuration Ends

    // line chart configuration Starts
    WidgetlineChart1: Chart = {
      type: 'Line', data: data['Dashboard1_WidgetlineChart1'],
      options: {
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0
        },
        axisY: {
          showGrid: false,
          low: 40,
          showLabel: false,
          offset: 0
        },
        plugins: [
          ChartistTooltip({
            appendToBody: true,
            currency: '$',
            pointClass: 'ct-point-regular'
          })
        ],
        lineSmooth: Chartist.Interpolation.cardinal({
          tension: 0
        }),
        fullWidth: true
      },
      events: {
        draw(data: any): void {
          if (data.type === 'point') {
            var circle = new Chartist.Svg('circle', {
              cx: data.x,
              cy: data.y,
              r: 4,
              'ct:value': data.value.y,
              'ct:meta': data.meta,
              style: 'pointer-events: all !important',
              class: 'ct-point-regular'
            });
            data.element.replace(circle);
          }
        }
      }
    };
    // Line chart configuration Ends

      // line chart configuration Starts
  WidgetlineChart2: Chart = {
    type: 'Line', data: data['Dashboard1_WidgetlineChart2'],
    options: {
      axisX: {
        showGrid: false,
        showLabel: false,
        offset: 0
      },
      axisY: {
        showGrid: false,
        low: 40,
        showLabel: false,
        offset: 0
      },
      plugins: [
        ChartistTooltip({
          appendToBody: true,
          currency: '$',
          pointClass: 'ct-point-regular'
        })
      ],
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 0
      }),
      fullWidth: true
    },
    events: {
      draw(data: any): void {
        if (data.type === 'point') {
          var circle = new Chartist.Svg('circle', {
            cx: data.x,
            cy: data.y,
            r: 4,
            'ct:value': data.value.y,
            'ct:meta': data.meta,
            style: 'pointer-events: all !important',
            class: 'ct-point-regular'
          });
          data.element.replace(circle);
        }
      }
    }
  };
  // Line chart configuration Ends

    // line chart configuration Starts
    WidgetlineChart3: Chart = {
      type: 'Line', data: data['Dashboard1_WidgetlineChart3'],
      options: {
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0
        },
        axisY: {
          showGrid: false,
          low: 40,
          showLabel: false,
          offset: 0
        },
        plugins: [
          ChartistTooltip({
            appendToBody: true,
            currency: '$',
            pointClass: 'ct-point-regular'
          })
        ],
        lineSmooth: Chartist.Interpolation.cardinal({
          tension: 0
        }),
        fullWidth: true
      },
      events: {
        draw(data: any): void {
          if (data.type === 'point') {
            var circle = new Chartist.Svg('circle', {
              cx: data.x,
              cy: data.y,
              r: 4,
              'ct:value': data.value.y,
              'ct:meta': data.meta,
              style: 'pointer-events: all !important',
              class: 'ct-point-regular'
            });
            data.element.replace(circle);
          }
        }
      }
    };

  ngOnInit(): void {
    this.getSettingList()
    this.filterSetting('Dashboard')
    this.filterSetting('today-thought')
    this.getAllRecord();
  }
  getAllRecord(){
    this.apiService.getAllRecords().subscribe((res:any)=>{
      this.usersLength = res?.data?.UserCount
      this.studentLength = res?.data?.StudentCount
      this.businessLength = res?.data?.BusinessCount
      this.courseCount = res?.data?.CourseCount
    })
  }
  public closeAlert(alert: IAlert) {
    debugger
    const index: number = this.general_info.indexOf(alert);
    this.general_info.splice(index, 1);
    this.showAlert = false;
  }
 
  getSettingList() {
    this.apiService.getAllSetting(1, 200).subscribe((res: any) => {
      if (!res?.items) {
        return;
      }
  
      const data = res.items;
  
      data.forEach((item) => {
        // Section 1: Stats Data
        if (item.key === 'stats') {
          this.stats_data = this.safeParse(item.value);
        }
  
        // Section 2: Hot Links
        if (item.key === 'hot-links') {
          this.hot_links = this.safeParse(item.value);
        }
  
        // Section 3: General Announcement
        if (item.key === 'general-announcement') {
          this.general_info = this.safeParse(item.value);
        }
  
        // Section 4: Quick Links
        if (item.key === 'quick-links') {
          const data_links = this.safeParse(item.value, []);
          this.quick_links = data_links.map((link) => {
            if (link.linkName.toLowerCase() === 'contract') {
              return { ...link, url: this.baseUrl + '/jobs/contracts' };
            }
            if (link.linkName.toLowerCase() === 'project') {
              return { ...link, url: this.baseUrl + '/jobs/projects' };
            }
            if (link.linkName.toLowerCase() === 'product') {
              return { ...link, url: this.baseUrl + '/jobs/products' };
            }
            if (link.linkName.toLowerCase() === 'contract audit') {
              return { ...link, url: this.baseUrl + '/project/contract-list' };
            }
            if (link.linkName.toLowerCase() === 'project audit') {
              return { ...link, url: this.baseUrl + '/project/project-list' };
            }
            if (link.linkName.toLowerCase() === 'product audit') {
              return { ...link, url: this.baseUrl + '/project/product-list' };
            }
            return link;
          });
        }
  
        // Section 5: Warning Message
        if (item.key === 'warning-message') {
          this.warn_message = this.safeParse(item.value);
        }
  
        // Section 6: Guideline Section 7
        if (item.key === 'guideline-section7') {
          this.guideline_section7 = this.safeParse(item.value);
        }
        if(item.key === 'section8') {
          this.data_section8 = this.safeParse(item.value);
          this.activeTab = this.data_section8[0]?.label;
          this.appById(this.data_section8[0]?.id)
        }
      });
  
      // Save settings data to localStorage
      const setting_data = JSON.stringify(data);
      if (setting_data) {
        localStorage.setItem('setting-record', setting_data);
      }
    });
  }
  
  // Helper function to safely parse JSON or return a default value
  safeParse(value: string | undefined, defaultValue: any = null): any {
    try {
      return value ? JSON.parse(value) : defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }
  
  

  createDynamicComponent(data:DynamicDetailData) {
    this.row_data =data
    // Create a factory for the dynamic component
    const factory = this.resolver.resolveComponentFactory(DynamicDetailComponent);

    // Create an instance of the dynamic component
    const componentRef = factory.create(this.dynamicContainer.injector);

    // Set the data for the dynamic component
    componentRef.instance.data = data;

    // Insert the dynamic component into the view container
    this.dynamicContainer.insert(componentRef.hostView);
  }

  createDynamicComponent2(data:DynamicDetailData2) {
    this.row_data =data
    // Create a factory for the dynamic component
    const factory = this.resolver.resolveComponentFactory(DynamicDetailComponent);

    // Create an instance of the dynamic component
    const componentRef = factory.create(this.todayThoughtContainer.injector);

    // Set the data for the dynamic component
    componentRef.instance.data = data;

    // Insert the dynamic component into the view container
    this.todayThoughtContainer.insert(componentRef.hostView);
  }
  filterSetting(data){
    if(data ==='Dashboard'){
      this.apiService.searchSettings(data).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.guideline_data = res?.data?.items
          this.createDynamicComponent(this.guideline_data[1]?this.guideline_data[1]:this.guideline_data[0])
        }
      })
    }
    if(data ==='today-thought'){
      this.apiService.searchSettings(data).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          this.today_thought_data = res?.data?.items
          this.createDynamicComponent(this.today_thought_data[0])
        }
      })
    }

    
  }
  gotoLink(url){
    if(url !=='' || url !== null || url !== undefined){
      window.open(url, "_blank");
    }
  }
  buttonClasses = ['btn btn-primary mr-1 mb-1', 'btn btn-secondary mr-1 mb-1', 'btn btn-success mr-1 mb-1', 'btn btn-danger mr-1 mb-1', 'btn btn-warning mr-1 mb-1', 'btn btn-info mr-1 mb-1', 'btn btn-light mr-1 mb-1', 'btn btn-dark mr-1 mb-1'];
  getRandomClass(index: number): string {
    return this.buttonClasses[index % this.buttonClasses.length];
  }
 

  setActiveTab(tab) {
    this.activeTab = tab.label;
    // console.log('=>> ', tab.id);

    // Update description for the item with the matching id
    this.data_section8 = this.data_section8.map((item) => {
        if (item.id === tab.id) {  // Ensure matching id
            // return {
            //     ...item,
            //     description: "Know Your Teacher: An innovative platform designed to connect students with their teachers more personally and thoughtfully. Our teachers mostly have more than 10 years of experience. They hold internationally reputed degrees such as Doctorates, IIM Certifications, and M.Tech. They demonstrate live projects to show how things happen in the industry."
            // };
            this.appById(tab.id)
        }
        return item;
    });

}
appById(id: string): void {
  this.apiService.getAppById(id).subscribe((res: any) => {
    if (res?.isSuccess) {
      this.app = res?.data[0];
      // Check if resources is an empty array and remove it from app if true
      if (this.app.resources.length === 0) {
        delete this.app.resources;
      }
    }
  });
}


openModal(content){
  
  const modalOptions: NgbModalOptions = {
    size: "lg",
    backdrop: "static",
  };
  const modalRef = this.modalService.open(content,modalOptions);
  modalRef.result.then(
    (result) => {
      
    },
    (reason) => {
      
    }
  );
}
currentEmployee(id){
  this.apiService.getEmployeeById(id).subscribe((res:any)=>{
    if(res?.isSuccess){
      this.tasks = res?.data
    }
  })
}
updateTask(){
  let body ={
    current_task:  this.tasks.current_task,
    next_task :  this.tasks.next_task
  }
  this.apiService.updateEmployee(this.user,body).subscribe((res:any)=>{
    if(res?.isSuccess){
      this.modalService.dismissAll()
      this.toastr.success(res?.message)
    }
    else this.toastr.error(res?.error)
  })
}
  
}



